import React, { useEffect, useState, useCallback } from "react";
import { api, apiError, fmtIDR } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Ban, ShieldCheck } from "lucide-react";

export function CancellationReport({ owner = false, branches = [] }) {
  const [bid, setBid] = useState("");
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const params = owner ? { branch_id: bid } : {};
      const { data } = await api.get("/transactions/cancelled", { params });
      setRows(data);
    } catch (e) { toast.error(apiError(e)); }
  }, [owner, bid]);
  useEffect(() => { load(); }, [load]);

  return (
    <Card className="card-surface rounded-2xl p-5" data-testid="cancellation-report">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 font-display text-lg font-bold text-neutral-900"><Ban className="text-crimson" size={18} /> Riwayat Pembatalan ({rows.length})</div>
        {owner && (
          <Select value={bid || "all"} onValueChange={(v) => setBid(v === "all" ? "" : v)}>
            <SelectTrigger data-testid="cancellation-branch" className="h-10 w-56 bg-neutral-100 border-neutral-200"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Semua Cabang</SelectItem>
              {branches.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm" data-testid="cancellation-table">
          <thead><tr className="border-b border-neutral-200 text-[11px] uppercase text-muted-foreground">
            <th className="py-2 pr-3">No Struk</th><th className="py-2 pr-3">Total</th><th className="py-2 pr-3">Kasir</th><th className="py-2 pr-3">Disetujui Oleh</th><th className="py-2">Waktu Batal</th>
          </tr></thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id} data-testid={`cancellation-row-${t.id}`} className="border-b border-neutral-200">
                <td className="py-2 pr-3 font-mono-num text-xs text-neutral-900 line-through opacity-80">{t.receipt_no}</td>
                <td className="py-2 pr-3 font-mono-num text-crimson">{fmtIDR(t.total)}</td>
                <td className="py-2 pr-3 text-xs text-muted-foreground">{t.cashier_name}</td>
                <td className="py-2 pr-3 text-xs"><span className="inline-flex items-center gap-1 rounded-full bg-gold/15 px-2 py-0.5 font-semibold text-gold"><ShieldCheck size={12} /> {t.cancelled_by || "-"}</span></td>
                <td className="py-2 text-xs text-muted-foreground">{t.cancelled_at ? new Date(t.cancelled_at).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-sm text-muted-foreground">Belum ada transaksi yang dibatalkan.</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
